/**
 * palinka zoldseg izek
 */
export type FruitSpiritVegetableFlavor =
  | 'BEETROOT'
  | 'PAPRIKA'
  | 'SHALLOTS'
  | 'TOMATO'
  | 'CARROT'
  | 'ASPARAGUS'
  | 'PUMPKIN'
  | 'CELERY'
  | 'OTHER';

export const FruitSpiritVegetableFlavor = {
  Beetroot: 'BEETROOT' as FruitSpiritVegetableFlavor,
  Paprika: 'PAPRIKA' as FruitSpiritVegetableFlavor,
  Shallots: 'SHALLOTS' as FruitSpiritVegetableFlavor,
  Tomato: 'TOMATO' as FruitSpiritVegetableFlavor,
  Carrot: 'CARROT' as FruitSpiritVegetableFlavor,
  Asparagus: 'ASPARAGUS' as FruitSpiritVegetableFlavor,
  Pumpkin: 'PUMPKIN' as FruitSpiritVegetableFlavor,
  Celery: 'CELERY' as FruitSpiritVegetableFlavor,
  Other: 'OTHER' as FruitSpiritVegetableFlavor,
};
